module.exports = __webpack_public_path__ + "static/media/20150508_122403.7b34179e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20150508_122403.jpg
// module id = 442
// module chunks = 0